<template>
  <li>
    <a
      href="#"
      class="media"
      @click.prevent="$emit('click', user.id)"
    >
      <div class="mr-3">
        <img
          src="@/static/user__1_.png"
          class="rounded-circle"
          width="44"
          height="44"
        >
      </div>
      <div class="media-body">
        <h6 class="media-title">{{ showUserNameOrEmail(user) }}</h6>
        <div class="text-muted font-size-sm">
          <span
            v-if="isOnline"
            class="text-success"
          >
            <i class="ri-record-circle-fill font-size-10 d-inline-block mr-1" />
            {{ $t('home.online') }}
          </span>
          <template v-else>
            <i class="ri-record-circle-fill font-size-10 d-inline-block mr-1" />
            {{ $t('home.offline') }}
          </template>
        </div>
      </div>
    </a>
  </li>
</template>

<script>
import {mapGetters} from "vuex";
import showUserNameOrEmail from '../../../../utils/showUserNameOrEmail';

export default {
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    isOnline() {
      const {status} = this.$store.state.user.status[this.user.id] || {}
      return status === 1
    },
  },
  methods: {
    showUserNameOrEmail,
  },
}
</script>

<style scoped>

</style>
